import LOCALE from '@/common/locale'
import LOCALE_AMENITY from '@/common/locale_amenity'

// return { term: definition, term: definition, ... }
function localeData (lang) {
  let obj = {}
  if (lang) {
    lang = lang.toLowerCase()
    LOCALE[lang].forEach(x => {
      obj[x.term] = x.definition
    })
  }
  return obj
}
function localeAmenityData (lang) {
  let obj = {}
  if (lang) {
    lang = lang.toLowerCase()
    LOCALE_AMENITY[lang].forEach(x => {
      obj[x.term] = x.definition
    })
  }
  return obj
}

function normalizeLocale(raw) {
  if (!raw) return 'en';
  // 예: 'zh-CN' 'zh-cn' 'zh_TW' -> 소문자, 구분자는 '-'
  return String(raw).trim().replace('_', '-').toLowerCase()
}

function resolveLang(requested, supported) {
  const lc = normalizeLocale(requested)

  // 1) 정확히 있으면 그대로
  if (supported.includes(lc)) return lc

  // 2) 언어-지역 분리 후 언어만으로 매칭 시도 (예: en-us -> en)
  const base = lc.split('-')[0]
  if (supported.includes(base)) return base

  // 3) 커스텀 폴백 체인
  const FALLBACK = {
    'zh-tw': 'zh-cn',
    'zh-hk': 'zh-cn',
    'zh-mo': 'zh-cn',
    'zh': 'zh-cn',
  };

  const mapped = FALLBACK[lc] || FALLBACK[base]
  if (mapped && supported.includes(mapped)) return mapped

  // 4) 최종 기본값
  return 'en'
}

export default {
  namespaced: true,
  state: {
    locale: {
      list: Object.keys(LOCALE),
      data: {}
    },
    localeAmenity: {
      list: Object.keys(LOCALE_AMENITY),
      data: {}
    },
    partner: null,
    lastRoute: sessionStorage.getItem('lastRoute') || null
  },
  mutations: {
    setLastRoute (state, route) {
      state.lastRoute = route
      sessionStorage.setItem('lastRoute', route)
    },
    setLocale (state, ln) {
      const supported = state.locale.list.map(x => x.toLowerCase())
      const lang = resolveLang(ln, supported) // 여기서 en/ko/ja/zh-cn 중 하나로 확정
      state.locale.data = localeData(lang)
      state.localeAmenity.data = localeAmenityData(lang)
    },
    setPartner (state) {
      const getHost = function (host) {
        if (host.includes('coreguide')) {
        // if (host.includes('8081')) {
          return 'CoreGuide'
        } else {
          return 'iSTAY'
        }
      }
      state.partner = {
        name: getHost(window.location.host),
        url: window.location.origin
      }
    }
  },
  getters: {
    getLastRoute: (state) => state.lastRoute
  }
}
